import React from 'react';
import { Link } from 'react-router-dom';
import Services from "../../api/Services";

import slider1 from '../../images/service/icon-3/1.jpg'



const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const ServiceSectionS3 = (props) => {

    return (
        <section className={"" + props.hclass}>
            <div className="container-fluid p-0">
                <div className="service-wrap">
                    <div className="service-slider">
                        <div className="service-slider scroll-text-animation" data-animation="fade_from_left">
                            <div className="item">
                                <img src={slider1} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="service-left scroll-text-animation" data-animation="fade_from_right">
                        {Services.slice(0, 3).map((service, item) => (
                            <div className="content " key={item}>
                                <div className="icon">
                                    <img src={service.Icon} alt="icon" />
                                </div>
                                <h2><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.title}</Link></h2>
                                <p>{service.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSectionS3;